var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLucidLinkConnecticon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 15.75V8.25",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 7.875C10.136 7.875 8.625 6.36396 8.625 4.5C8.625 2.63604 10.136 1.125 12 1.125C13.864 1.125 15.375 2.63604 15.375 4.5C15.375 6.36396 13.864 7.875 12 7.875Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 22.875C10.136 22.875 8.625 21.364 8.625 19.5C8.625 17.636 10.136 16.125 12 16.125C13.864 16.125 15.375 17.636 15.375 19.5C15.375 21.364 13.864 22.875 12 22.875Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLucidLinkConnecticon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;